/**
 * assertions.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export class AssertionError implements Error
{
  public readonly name : string = "Assertion Error";
  constructor (public message : string, public logObjects : any[] = []) {}
}

export function assertBoolean (val : boolean) : val is boolean
{
  if (val !== true && val !== false)
  {
    throw new AssertionError(`${val} is not a boolean!`);
  }
  return true;
}

export function assertString (val : string) : val is string
{
  if (typeof val !== "string")
  {
    throw new AssertionError(`${val} is not a string!`);
  }
  return true;
}

export function assertDate (val : Date) : val is Date
{
  if (!(val instanceof Date))
  {
    throw new AssertionError(`${val} is not a Date!`);
  }
  return true;
}

export function assertInteger (val : number) : val is number
{
  if (!Number.isSafeInteger(val))
  {
    throw new AssertionError(`${val} is not a safe integer!`, [val]);
  }
  return true;
}

export function assertNumber (val : number) : val is number
{
  if (!Number.isFinite(val))
  {
    throw new AssertionError(`${val} is not a number!`, [val]);
  }
  return true;
}

export function assertRange (val : number, [min, max] : [number, number]) : void
{
  if ((val < min) || (val > max))
  {
    throw new AssertionError(
      `${val} is outside range ${[min, max]}!`,
      [val, min, max]);
  }
}

export function assertArray (val : any[]) : val is any[]
{
  if (!Array.isArray(val))
  {
    throw new AssertionError(`${val} is not an array!`, [val]);
  }
  return true;
}

export function assertIndexInto (val : number, target : any[]) : void
{
  assertInteger(val);
  if (!(val in target))
  {
    throw new AssertionError(
      `${val} is not a valid index for ${target}`,
      [val, target]);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/utilities/assertions.ts